<div class="dashboard-main">

  <div class="filters">
    <div class="first-filter">
      <div class="date-picker">
        <yalo-daterange [dateStart]="fechaInicio" [dateEnd]="fechaFin" (onChange)="onChangeDate($event)"
          background="#ffffff" locale="es" [Time]="true" [saveTime]="true"></yalo-daterange>
      </div>
      <div class="date-select">
        <yalo-select [clear]="false" [value]="filterType" (change)="setFilterType($event)">
          <option value="1">En valor monetario</option>
          <option value="2">En cantidad</option>
        </yalo-select>
      </div>
    </div>
    <div class="second-filter">
      <div class="establecimiento">
        <div class="dashboard-filter-group" #filterGroup>
          <div class="dashboard-filter-section" (click)="isEstablecimientosExpanded = !isEstablecimientosExpanded">
            <div class="filter-text">Establecimientos</div>
            <i [ngClass]="{ 'icon-active': isEstablecimientosExpanded }" class="ri-arrow-down-s-line"></i>
          </div>
          <div class="dashboard-filter-content" [ngClass]="{ active: isEstablecimientosExpanded }">
            <div class="dashboard-filter-content-inner">
              <app-checkbox-item [checked]="AllEstablecimientosSelected()"
                (checkedChange)="toggleAllEstablecimientos()">
                <div class="dashboard-body-small">Seleccionar todo</div>
              </app-checkbox-item>
              <app-checkbox-item *ngFor="let establecimiento of establecimientos" [(checked)]="establecimiento.selected"
                (checkedChange)="onEstablecimientoChange()">
                <div class="dashboard-body-small">{{ establecimiento.NombreEstablecimiento }}</div>
              </app-checkbox-item>
            </div>
          </div>
        </div>
        <!-- <yalo-select
          [clear]="false"
          ngDefaultControl
          [formControl]="codEstablecimiento"
        >
          <option
            *ngFor="let establecimiento of establecimientos"
            [value]="establecimiento.CodEstablecimiento"
          >
            {{ establecimiento.NombreEstablecimiento }}
          </option>
        </yalo-select> -->
      </div>
    </div>
  </div>
  <section class="dashboard-container">


    <div class="first">
      <div class="dashboard-info">


        <div class="summary">
          <div class="summary-cards">
            <div class="icon">
              <i class="ri-money-dollar-circle-fill" style="color: #09cf71"></i>
            </div>
            <div class="total">
              <div class="body-x-small">Total facturado</div>
              <div class="headline-x-small">
                <!-- <span> -->
                <!-- <span *ngIf="filterType === 1">{{simboloMoneda}}</span> -->
                {{tarjetas?.Facturado ? configSvc.simboloMoneda + ' ' +
                [tarjetas?.Facturado | number:'1.2-2'] : '--'}}
                <!-- </span> -->
              </div>
            </div>
          </div>
          <div class="summary-cards">
            <div class="icon">
              <i class="ri-file-copy-2-fill" style="color: #52bae1"></i>
            </div>
            <div class="total">
              <div class="body-x-small">Facturas emitidas</div>
              <div class="headline-x-small">
                {{tarjetas?.Facturas ? [tarjetas?.Facturas | number] : '--'}}
              </div>
            </div>
          </div>
          <div class="summary-cards">
            <div class="icon">
              <i class="ri-file-list-fill" style="color: #f6d318"></i>
            </div>
            <div class="total">
              <div class="body-x-small">Pedidos abiertos</div>
              <div class="headline-x-small">
                {{tarjetas?.Pedidos ? [tarjetas?.Pedidos | number] : '--'}}
              </div>
            </div>
          </div>
          <div class="summary-cards">
            <div class="icon">
              <i class="ri-file-list-fill" style="color: #42677e"></i>
            </div>
            <div class="total">
              <div class="body-x-small">Total pedidos</div>
              <div class="headline-x-small">
                {{tarjetas?.PedidosTotal ? configSvc.simboloMoneda + ' ' +
                [tarjetas?.PedidosTotal | number:'1.2-2'] : '--'}}
              </div>
            </div>
          </div>
          <div class="summary-cards">
            <div class="icon">
              <i class="ri-service-fill" style="color: #ff4a4a"></i>
            </div>
            <div class="total">
              <div class="body-x-small">Clientes guardados</div>
              <div class="headline-x-small">
                {{tarjetas?.Clientes ? [tarjetas?.Clientes | number] : '--'}}
              </div>
            </div>
          </div>
        </div>
        <div class="wide-charts">
          <div class="wide-chart-card">
            <div class="chart-header">
              <div class="chart-title">
                <p class="headline-x-small">
                  {{filterType === 1 ? 'Ingresos' : 'Ventas' }} totales
                  <span class="body-small">(libro de ventas)</span>
                  <span class="body-small" *ngIf="chartService.filterChart !== 1">
                    *promedio del día</span>
                </p>
              </div>
              <div class="chart-options">
                <yalo-select [clear]="false" [value]="chartService.filterChart" (change)="setChartType($event)"
                  [disabled]="chartService.formattedInicio === chartService.formattedFin">
                  <option value="1">Por día</option>
                  <option value="2">Por hora</option>
                </yalo-select>
                <div class="chart-options">
                  <a class="body-x-small" routerLink="/dashboard/informes/libro-ventas-fiscal">Ver informe</a>
                </div>
              </div>
            </div>
            <div class="chart-container">
              <canvas id="ingresos-diarios"></canvas>
            </div>
          </div>
        </div>
        <div class="charts">
          <div class="chart-card">
            <div class="chart-header">
              <div class="chart-title">
                <p class="headline-x-small">
                  {{filterType === 1 ? 'Ingresos' : 'Ventas' }} por tipo de
                  pedido
                </p>
              </div>
              <div class="chart-options">
                <a class="body-x-small" routerLink="/dashboard/informes/tipo-pedido">Ver informe</a>
              </div>
            </div>
            <div class="chart-container">
              <canvas id="tipo-pedidos"></canvas>
            </div>
          </div>
          <div class="chart-card">
            <div class="chart-header">
              <div class="chart-title">
                <p class="headline-x-small">
                  {{filterType === 1 ? 'Ingresos' : 'Ventas' }} por método de
                  pago
                </p>
              </div>
              <div class="chart-options">
                <a class="body-x-small" routerLink="/dashboard/informes/metodo-pago">Ver informe</a>
              </div>
            </div>
            <div class="chart-container">
              <canvas id="metodos-pago"></canvas>
            </div>
          </div>
        </div>
        <div class="wide-charts">
          <div class="chart-card">
            <div class="chart-header">
              <div class="chart-title">
                <p class="headline-x-small">
                  {{filterType === 1 ? 'Ingresos' : 'Ventas' }} por categoría
                </p>
              </div>
              <div class="chart-options">
                <a class="body-x-small" routerLink="/dashboard/informes/categorias">Ver informe</a>
              </div>
            </div>
            <div class="chart-container">
              <canvas id="ingresos-categoria"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="second">
      <div class="details-info">
        <div class="slider">
          <swiper [config]="config">
            <ng-container *ngIf="correlativos?.length > 0; else noPuntoEmision">
              <ng-template swiperSlide *ngFor="let correlativo of correlativos">
                <p class="headline-x-small">Uso del correlativo activo</p>
                <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                <div *ngIf="correlativo; else noCorrelativo">
                  <div class="progress">
                    <div class="bar">
                      <div [ngStyle]="{'width': correlativo.Porcentaje + '%' }" [ngClass]="{
                      'high' : correlativo.Porcentaje <= 50, 
                      'medium' : correlativo.Porcentaje >= 51 && correlativo.Porcentaje <= 89, 
                      'low' : correlativo.Porcentaje > 90
                    }"></div>
                    </div>
                    <div class="percentage body-x-small">
                      {{correlativo.Porcentaje | percent : '1.2-2'}}
                    </div>
                  </div>
                  <div class="detail-info">
                    <div class="card-info">
                      <div class="detail-names body-small">
                        Punto de emisión
                      </div>
                      <yalo-pills color="notification">
                        <div class="body-small">
                          {{correlativo.NombrePuntoEmision}}
                        </div>
                      </yalo-pills>
                    </div>
                    <div class="divider">
                      <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                    </div>
                  </div>
                  <div class="detail-info">
                    <div class="card-info">
                      <div class="detail-names body-small">
                        Facturas restantes
                      </div>
                      <yalo-pills color="notification">
                        <div class="body-small">
                          {{correlativo.NumeroFinal - correlativo.UltimoNumero}}
                        </div>
                      </yalo-pills>
                    </div>
                    <div class="divider">
                      <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                    </div>
                  </div>
                  <div class="detail-info">
                    <div class="card-info">
                      <div class="detail-names body-small">Último usado</div>
                      <yalo-pills color="notification">
                        <div class="body-small">
                          {{correlativo.UltimoNumero}}
                        </div>
                      </yalo-pills>
                    </div>
                    <div class="divider">
                      <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                    </div>
                  </div>
                  <div class="detail-info">
                    <div class="card-info">
                      <div class="detail-names body-small">
                        Fecha Límite Emisión
                      </div>
                      <yalo-pills color="error">
                        <div class="body-small">
                          {{correlativo.FechaHasta | date: "d/MM/yyyy"}}
                        </div>
                      </yalo-pills>
                    </div>
                  </div>
                  <div class="expires-soon" *ngIf="correlativo.ExpiresSoon">
                    <div class="body-x-small">
                      Tu correlativo está pronto a
                      <span class="subtitle-small">terminarse</span>. Solicita
                      uno nuevo.
                    </div>
                  </div>
                </div>
                <ng-template #noCorrelativo>
                  <div class="detail-info">
                    <div class="card-info">
                      <div class="detail-names body-small">
                        Punto de emisión
                      </div>
                      <yalo-pills color="notification">
                        <div class="body-small">
                          {{correlativo.NombrePuntoEmision}}
                        </div>
                      </yalo-pills>
                    </div>
                    <div class="divider">
                      <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                    </div>
                  </div>
                  <div class="noCorrelativo">
                    <div class="headline-x-small">
                      No tienes correlativo activo en este punto de emisión
                    </div>
                    <button class="yc-btn yc-btn-tertary button-medium">
                      Agregar correlativo
                      <i class="ri-add-circle-line"></i>
                    </button>
                  </div>
                </ng-template>
              </ng-template>
            </ng-container>
            <ng-template #noPuntoEmision>
              <ng-template swiperSlide *ngFor="let correlativo of correlativos">
                <p class="headline-x-small">Uso del correlativo activo</p>
                <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
                <div class="body-x-small">hey!</div>
              </ng-template>
            </ng-template>
          </swiper>
        </div>
        <div class="detail-card">
          <p class="headline-x-small">Productos más vendidos</p>
          <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
          <ng-container *ngIf="dashboard?.ProductosMasVendidos.length > 0; else noProducts">
            <div class="detail-info" *ngFor="let producto of dashboard?.ProductosMasVendidos; let i=index">
              <div class="card-info">
                <!-- <div class="avatar">
                <img
                  src="{{producto.ImagenProducto}}"
                  *ngIf="
                  producto.ImagenProducto.substring(0, 5) === 'https';
                else noProductPhoto
              "
                />
                <ng-template #noProductPhoto>
                  <i class="ri-image-2-line"></i>
                </ng-template>
              </div> -->
                <div class="detail-names body-small">
                  {{producto.NombreProducto}}
                </div>
                <yalo-pills color="success" class="wide-pill">
                  <div class="body-small">
                    <span *ngIf="filterType === 1">{{configSvc.simboloMoneda}}</span>
                    {{filterType === 1 ? [producto.Total | number:'1.2-2'] :
                    producto.Cantidad }}
                  </div>
                </yalo-pills>
              </div>
              <div class="divider">
                <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
              </div>
            </div>
          </ng-container>
          <ng-template #noProducts>
            <div class="detail-info">
              <div class="noProducts">
                <div class="headline-x-small">
                  No tienes productos disponibles
                </div>
                <button class="yc-btn yc-btn-tertary button-medium">
                  Agregar productos
                  <i class="ri-add-circle-line"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </div>
        <div class="detail-card">
          <p class="headline-x-small">Clientes frecuentes</p>
          <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
          <ng-container *ngIf="dashboard?.MejoresClientes.length > 0; else noClients">
            <div class="total-visitas body-x-small">
              {{filterType === 1 ? 'Total gastado' : 'Total visitas'}}
            </div>
            <div class="detail-info" *ngFor="let cliente of dashboard?.MejoresClientes">
              <div class="card-info">
                <div class="detail-names body-small">
                  {{cliente.NombreCliente}}
                </div>
                <yalo-pills color="success" class="wide-pill">
                  <div class="body-x-small">
                    <span *ngIf="filterType === 1">{{configSvc.simboloMoneda}}</span>
                    {{filterType === 1 ? [cliente.Total | number:'1.2-2']:
                    cliente.Cantidad }}
                  </div>
                </yalo-pills>
              </div>
              <div class="divider">
                <yalo-divider background="var(--gray100)" size="1"></yalo-divider>
              </div>
            </div>
          </ng-container>
          <ng-template #noClients>
            <div class="detail-info">
              <div class="noClients">
                <div class="headline-x-small">
                  No tienes clientes disponibles
                </div>
                <button class="yc-btn yc-btn-tertary button-medium">
                  Agregar clientes
                  <i class="ri-add-circle-line"></i>
                </button>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </section>
</div>